if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
/* =========================================
   Product Image Modal – Pinch to Zoom
========================================= */

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('product-modal');
  if (!modal) return;

  let scale = 1;
  let startDistance = 0;
  let lastScale = 1;

  function getDistance(touches) {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.hypot(dx, dy);
  }

  function resetZoom(img) {
    scale = 1;
    lastScale = 1;
    img.style.transform = 'scale(1)';
  }

  /* Reset zoom every time modal opens */
  modal.addEventListener('show', () => {
    const img = modal.querySelector('img');
    if (img) resetZoom(img);
  });

  /* Detect pinch start */
  modal.addEventListener(
    'touchstart',
    (e) => {
      const img = e.target.closest('img');
      if (!img || e.touches.length !== 2) return;
      startDistance = getDistance(e.touches);
      lastScale = scale;
    },
    { passive: false }
  );

  /* Pinch zoom */
  modal.addEventListener(
    'touchmove',
    (e) => {
      const img = e.target.closest('img');
      if (!img || e.touches.length !== 2) return;

      e.preventDefault();

      const currentDistance = getDistance(e.touches);
      scale = Math.min(
        Math.max(lastScale * (currentDistance / startDistance), 1),
        4
      );

      img.style.transform = `scale(${scale})`;
    },
    { passive: false }
  );
});
